var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 19,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M15.681.5h3.055l-6.672 7.624L19.912 18.5h-6.144l-4.816-6.291L3.449 18.5H.389l7.135-8.156L0 .5h6.3l4.349 5.75zm-1.073 16.174H16.3L5.378 2.231H3.561z"
})));
export { SvgTwitterX as ReactComponent };
export default __webpack_public_path__ + "9f207478bf635353815c4e203b244d96.svg";